import type { z } from "zod";
import addAccountMember from "./addAccountMember.js";
import addComment from "./addComment.js";
import backfillTrackedCategorySuggestions from "./backfillTrackedCategorySuggestions.js";
import cancelTransferRequest from "./cancelTransferRequest.js";
import createAccount from "./createAccount.js";
import createAdmin from "./createAdmin.js";
import createApiKey from "./createApiKey.js";
import createStripeSubscription from "./createStripeSubscription.js";
import createSupervisorOrg from "./createSupervisorOrg.js";
import createSupervisorOrgUser from "./createSupervisorOrgUser.js";
import createTransferRequest from "./createTransferRequest.js";
import createTreezorAccount from "./createTreezorAccount.js";
import createTreezorBeneficiary from "./createTreezorBeneficiary.js";
import createTreezorBeneficiarySCAPayload from "./createTreezorBeneficiarySCAPayload.js";
import createTreezorDocumentUploadForAccount from "./createTreezorDocumentUploadForAccount.js";
import createTreezorDocumentUploadForUser from "./createTreezorDocumentUploadForUser.js";
import createTreezorEffectiveBeneficiary from "./createTreezorEffectiveBeneficiary.js";
import createTreezorPayout from "./createTreezorPayout.js";
import createTreezorPayoutSCAPayload from "./createTreezorPayoutSCAPayload.js";
import createTreezorPowerOfAttorneyUpload from "./createTreezorPowerOfAttorneyUpload.js";
import deleteAccount from "./deleteAccount.js";
import deleteAccountInvitation from "./deleteAccountInvitation.js";
import deleteAdmin from "./deleteAdmin.js";
import deleteContractTemplate from "./deleteContractTemplate.js";
import deleteSupervisorOrg from "./deleteSupervisorOrg.js";
import deleteSupervisorOrgUser from "./deleteSupervisorOrgUser.js";
import deleteTreezorDocumentForAccount from "./deleteTreezorDocumentForAccount.js";
import deleteTreezorDocumentForUser from "./deleteTreezorDocumentForUser.js";
import deleteTreezorEffectiveBeneficiary from "./deleteTreezorEffectiveBeneficiary.js";
import deleteTreezorSCAWallet from "./deleteTreezorSCAWallet.js";
import enrollTreezorSCA from "./enrollTreezorSCA.js";
import enrollTreezorSCAPayload from "./enrollTreezorSCAPayload.js";
import exportDailyBalances from "./exportDailyBalances.js";
import fetchGclAccounts from "./fetchGclAccounts.js";
import generateTrackedCategories from "./generateTrackedCategories.js";
import getAccountBankDetails from "./getAccountBankDetails.js";
import getBridgeLink from "./getBridgeLink.js";
import getContractSigningUrl from "./getContractSigningUrl.js";
import getContractUrl from "./getContractUrl.js";
import getGclLink from "./getGclLink.js";
import getPowensLink from "./getPowensLink.js";
import getSupervisorOrgDashboard from "./getSupervisorOrgDashboard.js";
import getTransactionFileUrl from "./getTransactionFileUrl.js";
import getTransferRequestFileUrl from "./getTransferRequestFileUrl.js";
import getTreezorAccountCreator from "./getTreezorAccountCreator.js";
import getTreezorAccountMember from "./getTreezorAccountMember.js";
import getTreezorDocumentsForAccount from "./getTreezorDocumentsForAccount.js";
import getTreezorDocumentUrlForAccount from "./getTreezorDocumentUrlForAccount.js";
import getTreezorDocumentUrlForUser from "./getTreezorDocumentUrlForUser.js";
import getTreezorEffectiveBeneficiaries from "./getTreezorEffectiveBeneficiaries.js";
import getTreezorSCAWallets from "./getTreezorSCAWallets.js";
import getWebhookDashboardUrl from "./getWebhookDashboardUrl.js";
import inviteTreezorAccountBySiren from "./inviteTreezorAccountBySiren.js";
import listAdmins from "./listAdmins.js";
import listGclBanks from "./listGclBanks.js";
import listPappersCompanyPeople from "./listPappersCompanyPeople.js";
import markCommentsRead from "./markCommentsRead.js";
import markTreezorKycReadyForAdminReview from "./markTreezorKycReadyForAdminReview.js";
import refuseAccountInvitation from "./refuseAccountInvitation.js";
import resendUserInvitationEmail from "./resendUserInvitationEmail.js";
import resetUserMfa from "./resetUserMfa.js";
import reviewTransferRequest from "./reviewTransferRequest.js";
import reviewTreezorDocumentForAccount from "./reviewTreezorDocumentForAccount.js";
import reviewTreezorDocumentForUser from "./reviewTreezorDocumentForUser.js";
import reviewTreezorKycAdmin from "./reviewTreezorKycAdmin.js";
import sendOperatorConnectLinkEmail from "./sendOperatorConnectLinkEmail.js";
import sendSupportMessage from "./sendSupportMessage.js";
import sendSwanOnboardingLink from "./sendSwanOnboardingLink.js";
import sendTreezorUserInvitationEmail from "./sendTreezorUserInvitationEmail.js";
import sendUserEmailChangeEmail from "./sendUserEmailChangeEmail.js";
import sendUserPasswordResetEmail from "./sendUserPasswordResetEmail.js";
import sendUserVerificationEmail from "./sendUserVerificationEmail.js";
import setBridgeAccount from "./setBridgeAccount.js";
import setGclAccount from "./setGclAccount.js";
import signInWithTreezorSCA from "./signInWithTreezorSCA.js";
import signInWithTreezorSCAPayload from "./signInWithTreezorSCAPayload.js";
import simulateTreezorCreditWallet from "./simulateTreezorCreditWallet.js";
import simulateTreezorKYBFlow from "./simulateTreezorKYBFlow.js";
import simulateTreezorPayoutValidation from "./simulateTreezorPayoutValidation.js";
import simulateTreezorScaProof from "./simulateTreezorScaProof.js";
import startTreezorKycLiveness from "./startTreezorKycLiveness.js";
import stopOperatorNotifications from "./stopOperatorNotifications.js";
import submitTreezorAccountMemberOnboarding from "./submitTreezorAccountMemberOnboarding.js";
import syncPowensConnection from "./syncPowensConnection.js";
import syncTreezorAccount from "./syncTreezorAccount.js";
import testContractTemplate from "./testContractTemplate.js";
import updateTreezorAccountCreator from "./updateTreezorAccountCreator.js";
import updateTreezorAccountMember from "./updateTreezorAccountMember.js";
import updateTreezorCompany from "./updateTreezorCompany.js";
import updateTreezorEffectiveBeneficiary from "./updateTreezorEffectiveBeneficiary.js";
import validateTreezorBeneficiary from "./validateTreezorBeneficiary.js";

export const callables = {
  addComment,
  markCommentsRead,
  reviewTransferRequest,
  backfillTrackedCategorySuggestions,
  cancelTransferRequest,
  createAdmin,
  deleteAdmin,
  listAdmins,
  getTransactionFileUrl,
  getTransferRequestFileUrl,
  getContractUrl,
  createSupervisorOrg,
  createAccount,
  deleteSupervisorOrg,
  deleteAccount,
  deleteContractTemplate,
  getBridgeLink,
  setBridgeAccount,
  sendOperatorConnectLinkEmail,
  resendUserInvitationEmail,
  resetUserMfa,
  sendTreezorUserInvitationEmail,
  markTreezorKycReadyForAdminReview,
  reviewTreezorKycAdmin,
  sendUserVerificationEmail,
  sendUserPasswordResetEmail,
  sendUserEmailChangeEmail,
  sendSupportMessage,
  createApiKey,
  fetchGclAccounts,
  deleteSupervisorOrgUser,
  generateTrackedCategories,
  getGclLink,
  setGclAccount,
  getPowensLink,
  getAccountBankDetails,
  listGclBanks,
  listPappersCompanyPeople,
  createSupervisorOrgUser,
  addAccountMember,
  sendSwanOnboardingLink,
  getWebhookDashboardUrl,
  testContractTemplate,
  exportDailyBalances,
  createStripeSubscription,
  createTransferRequest,
  stopOperatorNotifications,
  syncPowensConnection,
  syncTreezorAccount,
  getSupervisorOrgDashboard,
  inviteTreezorAccountBySiren,
  deleteAccountInvitation,
  refuseAccountInvitation,
  getContractSigningUrl,
  createTreezorBeneficiary,
  createTreezorBeneficiarySCAPayload,
  createTreezorDocumentUploadForUser,
  createTreezorDocumentUploadForAccount,
  createTreezorPayout,
  createTreezorPayoutSCAPayload,
  createTreezorAccount,
  createTreezorEffectiveBeneficiary,
  deleteTreezorDocumentForUser,
  deleteTreezorDocumentForAccount,
  deleteTreezorEffectiveBeneficiary,
  getTreezorDocumentsForAccount,
  getTreezorDocumentUrlForUser,
  getTreezorDocumentUrlForAccount,
  reviewTreezorDocumentForUser,
  reviewTreezorDocumentForAccount,
  getTreezorEffectiveBeneficiaries,
  getTreezorAccountCreator,
  getTreezorAccountMember,
  createTreezorPowerOfAttorneyUpload,
  submitTreezorAccountMemberOnboarding,
  enrollTreezorSCA,
  enrollTreezorSCAPayload,
  getTreezorSCAWallets,
  deleteTreezorSCAWallet,
  signInWithTreezorSCA,
  signInWithTreezorSCAPayload,
  simulateTreezorCreditWallet,
  simulateTreezorKYBFlow,
  simulateTreezorPayoutValidation,
  simulateTreezorScaProof,
  startTreezorKycLiveness,
  updateTreezorCompany,
  updateTreezorAccountCreator,
  updateTreezorAccountMember,
  updateTreezorEffectiveBeneficiary,
  validateTreezorBeneficiary,
} as const;

export type CallablesMap = {
  [K in keyof typeof callables]: {
    params: z.input<(typeof callables)[K]["params"]>;
    response: z.output<(typeof callables)[K]["response"]>;
  };
};

export type CallableEnvelope<K extends keyof CallablesMap = keyof CallablesMap> = {
  action: K;
  params: CallablesMap[K]["params"];
};
